import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { Modal, List } from 'semantic-ui-react';
import { get } from 'lodash';
import { states } from '@/constants/lifecycle';
import DialogWrapper from '@/components/dialogs/DialogWrapper';
import { transferRequest, hideTransferRequest } from '../actions';
import RequestDatasetListItem from '../datasets/containers/RequestDatasetListItem';
import RequestAttachmentListItem from '../attachments/components/RequestAttachmentListItem';
import RequestDictionariesListItem from '../datasets/containers/RequestDictionariesListItem';
import RequestWorkspaceListItem from '../workspaces/components/RequestWorkspaceListItem';
import { requestTransferTypes } from '../constants';
import { requestTransferMessage, withDictionariesTransferType } from '../helper';
import RequestTransferDialogActions from '../components/RequestTransferDialogActions';

const RequestTransferDialog = ({
  allowPmnTransfer,
  code,
  hide,
  hub,
  name,
  results,
  showDictionaries,
  supportsAutoTransfer,
  theme,
  transfer,
  url,
  withLink,
}) => {
  const intl = useIntl();
  const loading = results.some((result) => result.readStatus === states.PENDING);

  const titleText = useMemo(() => {
    const transferTitles = {};
    transferTitles[requestTransferTypes.MANUAL] = 'request.transfer.manual.title';
    transferTitles[requestTransferTypes.CLEAR] = 'request.transfer.clear.title';
    transferTitles[requestTransferTypes.PMN] = 'request.transfer.pseudonymised.title';
    transferTitles[requestTransferTypes.TOKEN] = 'request.transfer.token.title';
    let message = 'request.transfer.title';
    if (results.length === 1 && allowPmnTransfer) {
      message = transferTitles[results[0].transfer.transfer_type];
    }

    return intl.formatMessage({ id: message });
  }, [allowPmnTransfer, intl, results]);

  return (
    <DialogWrapper
      className="aridhia-request-transfer-dialog"
      icon="exchange"
      loading={loading}
      message={requestTransferMessage(supportsAutoTransfer, url)}
      onClose={hide}
      theme={theme}
      title={titleText}
    >
      <Modal.Content scrolling>
        <List className="aridhia-request-transfer-list">
          <RequestDatasetListItem code={code} category="transfer" />
          {showDictionaries && <RequestDictionariesListItem code={code} category="transfer" />}
          <RequestAttachmentListItem code={code} category="transfer" />
          <RequestWorkspaceListItem value={name} url={withLink ? url : null} />
          <RequestWorkspaceListItem value={hub} header="hub" />
        </List>
      </Modal.Content>
      <RequestTransferDialogActions
        hide={hide}
        loading={loading}
        results={results}
        supportsAutoTransfer={supportsAutoTransfer}
        transfer={transfer}
        url={url}
      />
    </DialogWrapper>
  );
};

const mapStateToProps = ({
  auth: { currentUser },
  requests: { requests, allowPmnTransfer },
}) => {
  const { results } = requests.transfer;
  const {
    supports_automated_transfer: supportsAutoTransfer,
    transfer_type: transferType,
  } = get(results, '[0].transfer', {});

  return ({
    allowPmnTransfer,
    code: results[0]?.code || '',
    hub: results[0]?.workspace_location,
    name: results[0]?.workspace_name,
    results,
    showDictionaries: withDictionariesTransferType(transferType),
    supportsAutoTransfer,
    url: results[0]?.workspace_inbox_url,
    withLink: results[0]?.requester?.uuid === currentUser.id,
  });
};

const mapDispatchToProps = {
  hide: hideTransferRequest,
  transfer: transferRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestTransferDialog);
